import {BehaviorSubject, Observable} from "rxjs";
import {isPlatformBrowser} from "@angular/common";
import {inject, Injectable, PLATFORM_ID} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceCapabilityService {
  private platformId: Object = inject(PLATFORM_ID);
  private hoverSupportSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const mql: MediaQueryList = window.matchMedia('(hover: hover)');
      this.hoverSupportSubject.next(mql.matches);
      mql.addEventListener('change', (e) => {
        this.hoverSupportSubject.next(e.matches);
      });
    }
  }

  public hasHoverSupport(): Observable<boolean> {
    return this.hoverSupportSubject.asObservable();
  }
}
